<app-sidebar></app-sidebar>

<div class="landing-page-container page-container">
  <app-header></app-header>

  <div class="container-fluid py-4">
    <div class="row g-4 align-items-start">
      <div class="col-12" [class.col-xl-8]="showWidgetComunicazioni" [class.col-xl-12]="!showWidgetComunicazioni">
        <!-- Header -->
        <div class="mb-4 text-center">
          <h1 class="mb-2 landing-title">
            <span class="landing-title-primary">Le tue </span>
            <span class="landing-title-warning">applicazioni</span>
          </h1>
          <p class="landing-subtitle mb-0">Seleziona un'applicazione su cui accedere</p>
        </div>

        <!-- Loading State -->
        @if (isLoadingApps()) {
          <div class="text-center py-5 px-3">
            <ngb-progressbar [animated]="true" [striped]="true" [value]="100" height="6px" type="primary" />
            <p class="mt-3 text-muted mb-0">Caricamento applicazioni disponibili...</p>
            <span class="visually-hidden">Caricamento applicazioni...</span>
          </div>
        }

        <!-- Apps Grid: vista piatta (una card per profilo) -->
        @if (!isLoadingApps() && !raggruppaProfili && landingAccessCards().length > 0) {
          <div class="row g-4">
            @for (card of landingAccessCards(); track card.cardId) {
              <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                @if (card.kind === 'profile') {
                  <button
                    type="button"
                    class="btn btn-app w-100 h-100 p-4 d-flex flex-column align-items-center justify-content-start"
                    [disabled]="!card.app.abilitato"
                    (click)="onProfileClick(card.key, card.id_profilo!, card.url)"
                  >
                    <div class="app-icon-wrap mb-3">
                      <img
                        [src]="card.app.icona"
                        [alt]="card.app.nome"
                        class="app-icon"
                        (error)="onAppIconError($event)"
                      />
                    </div>

                    <div class="app-text-content">
                      <h5 class="mb-1 text-center text-muted small">{{ card.app.nome }}</h5>
                      <p class="mb-0 text-center app-name-title">
                        @if (isProfileRoleSameAsApp(card.app.nome, card.ruolo)) {
                          <span class="app-name-line">{{ card.username }}</span>
                        } @else {
                          <span class="app-name-line">{{ card.ruolo }}</span>
                          <span class="app-name-line">{{ card.username }}</span>
                        }
                      </p>

                      @if (!card.app.abilitato) {
                        <span class="badge bg-secondary mt-2">Non disponibile</span>
                      }
                    </div>
                  </button>
                }

                @if (card.kind === 'no-profile') {
                  <button
                    type="button"
                    class="btn btn-app app-single-no-profile w-100 h-100 p-4 d-flex flex-column align-items-center justify-content-start"
                    [disabled]="!card.app.abilitato"
                    (click)="onAppSenzaProfiloClick(card.key, card.app)"
                  >
                    <div class="app-icon-wrap mb-3">
                      <img
                        [src]="card.app.icona"
                        [alt]="card.app.nome"
                        class="app-icon"
                        (error)="onAppIconError($event)"
                      />
                    </div>

                    <div class="app-text-content">
                      <h5 class="mb-1 text-center text-muted small">{{ card.app.nome }}</h5>
                      <p class="mb-0 text-center app-name-title">senza profilo</p>

                      @if (!card.app.abilitato) {
                        <span class="badge bg-secondary mt-2">Non disponibile</span>
                      }
                    </div>
                  </button>
                }
              </div>
            }
          </div>
        }

        <!-- Apps Grid raggruppate per nome app -->
        @if (!isLoadingApps() && raggruppaProfili && targetAppsWithProfiles().length > 0) {
          <div class="row g-4">
            @for (targetAppWithProfiles of targetAppsWithProfiles(); track targetAppWithProfiles.nome) {
              <!-- Se ha una sola opzione (un profilo OPPURE solo app senza profilo): pulsante semplice -->
              @if (getTotalOptionsForApp(targetAppWithProfiles) === 1) {
                <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                  <!-- Caso: esiste un profilo -->
                  @if (targetAppWithProfiles.profiles.length === 1) {
                    <button
                      type="button"
                      class="btn btn-app w-100 h-100 p-4 d-flex flex-column align-items-center justify-content-start"
                      [disabled]="!targetAppWithProfiles.app.abilitato"
                      (click)="onProfileClick(targetAppWithProfiles.profiles[0].key, targetAppWithProfiles.profiles[0].id_profilo, targetAppWithProfiles.profiles[0].url)"
                    >
                      <!-- Icona App -->
                      <div class="app-icon-wrap mb-3">
                        <img
                          [src]="targetAppWithProfiles.app.icona"
                          [alt]="targetAppWithProfiles.app.nome"
                          class="app-icon"
                          (error)="onAppIconError($event)"
                        />
                      </div>

                      <div class="app-text-content">
                        <!-- Nome App -->
                        <h5 class="mb-1 text-center text-muted small">{{ targetAppWithProfiles.app.nome }}</h5>

                        <!-- Descrizione App -->
                        <!-- @if (targetAppWithProfiles.app.descrizione) {
                          <p class="app-description mb-1 small text-center text-truncate">
                            {{ targetAppWithProfiles.app.descrizione }}
                          </p>
                        } -->

                        <!-- Username (descrizione) -->
                        <p class="mb-0 text-center app-name-title">{{ targetAppWithProfiles.profiles[0].username }}</p>

                        <!-- Badge Disabilitato -->
                        @if (!targetAppWithProfiles.app.abilitato) {
                          <span class="badge bg-secondary mt-2">Non disponibile</span>
                        }
                      </div>
                    </button>
                  }

                  <!-- Caso: nessun profilo, solo app senza profilo -->
                  @if (targetAppWithProfiles.profiles.length === 0 && targetAppWithProfiles.noProfileApp) {
                    <button
                      type="button"
                      class="btn btn-app app-single-no-profile w-100 h-100 p-4 d-flex flex-column align-items-center justify-content-start"
                      [disabled]="!targetAppWithProfiles.noProfileApp.app.abilitato"
                      (click)="onAppSenzaProfiloClick(targetAppWithProfiles.noProfileApp.key, targetAppWithProfiles.noProfileApp.app)"
                    >
                      <!-- Icona App -->
                      <div class="app-icon-wrap mb-3">
                        <img
                          [src]="targetAppWithProfiles.noProfileApp.app.icona"
                          [alt]="targetAppWithProfiles.noProfileApp.app.nome"
                          class="app-icon"
                          (error)="onAppIconError($event)"
                        />
                      </div>

                      <div class="app-text-content">
                        <!-- Nome App -->
                        <h5 class="mb-1 text-center text-muted small">{{ targetAppWithProfiles.noProfileApp.app.nome }}</h5>

                        <!-- Descrizione -->
                        <!-- <p class="app-description mb-0 small text-center">
                          {{ targetAppWithProfiles.noProfileApp.app.descrizione || 'Accedi senza selezionare un profilo.' }}
                        </p> -->

                        <!-- Badge Disabilitato -->
                        @if (!targetAppWithProfiles.noProfileApp.app.abilitato) {
                          <span class="badge bg-secondary mt-2">Non disponibile</span>
                        }
                      </div>
                    </button>
                  }
                </div>
              }
              
              <!-- Se ha più opzioni (profili multipli e/o variante senza profilo): card principale con pulsanti annidati -->
              @if (getTotalOptionsForApp(targetAppWithProfiles) > 1) {
                <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                  <div
                    class="btn-app app-multi-shell w-100 h-100 p-4 d-flex flex-column align-items-center justify-content-start"
                    [class.app-disabled]="!targetAppWithProfiles.app.abilitato"
                    (click)="onProfileRequiredCardClick(targetAppWithProfiles, $event)"
                  >
                      <div class="app-multi-content">
                        <div class="app-icon-wrap mb-3">
                          <img
                            [src]="targetAppWithProfiles.app.icona"
                            [alt]="targetAppWithProfiles.app.nome"
                            class="app-icon"
                            (error)="onAppIconError($event)"
                          />
                        </div>
                        <div class="app-text-content">
                          <h5 class="mb-1 text-center text-muted small">{{ targetAppWithProfiles.app.nome }}</h5>
                          <!-- @if (targetAppWithProfiles.app.descrizione) {
                            <p class="app-description mb-1 small text-center text-truncate">
                              {{ targetAppWithProfiles.app.descrizione }}
                            </p>
                          } -->
                          <div
                            class="app-name-row"
                            role="button"
                            [attr.tabindex]="targetAppWithProfiles.app.abilitato ? 0 : -1"
                            [attr.aria-expanded]="!isProfilesCollapsed(targetAppWithProfiles)"
                            [class.app-name-row-disabled]="!targetAppWithProfiles.app.abilitato"
                            (click)="targetAppWithProfiles.app.abilitato && toggleProfilesCollapse(targetAppWithProfiles)"
                            (keydown.enter)="targetAppWithProfiles.app.abilitato && toggleProfilesCollapse(targetAppWithProfiles)"
                            (keydown.space)="targetAppWithProfiles.app.abilitato && toggleProfilesCollapse(targetAppWithProfiles)"
                          >
                            <button
                              type="button"
                              class="profile-collapse-toggle app-name-title"
                              [disabled]="!targetAppWithProfiles.app.abilitato"
                              tabindex="-1"
                              [attr.aria-expanded]="!isProfilesCollapsed(targetAppWithProfiles)"
                            >
                              Seleziona un profilo per accedere
                            </button>
                          </div>
                          @if (!targetAppWithProfiles.app.abilitato) {
                            <span class="badge bg-secondary mb-2">In manutenzione</span>
                          }
                        </div>
                      </div>

                      <div class="profiles-collapse" [ngbCollapse]="isProfilesCollapsed(targetAppWithProfiles)">
                        <div class="d-grid gap-2">
                          @for (profile of targetAppWithProfiles.profiles; track profile.id_profilo + profile.key) {
                            <button
                              type="button"
                              class="btn btn-outline-primary btn-profile text-start"
                              [disabled]="!targetAppWithProfiles.app.abilitato"
                              (click)="onProfileClick(profile.key, profile.id_profilo, profile.url)"
                              [ngbTooltip]="targetAppWithProfiles.app.abilitato ? 'Accedi con ' + (isProfileRoleSameAsApp(targetAppWithProfiles.app.nome, profile.ruolo) ? profile.username : (profile.ruolo + ' ' + profile.username)) : 'Applicazione non disponibile'"
                              container="body"
                            >
                              @if (isProfileRoleSameAsApp(targetAppWithProfiles.app.nome, profile.ruolo)) {
                                <span class="app-name-line">{{ profile.username }}</span>
                              } @else {
                                <span class="app-name-line">{{ profile.ruolo }}</span>
                                <span class="app-name-line">{{ profile.username }}</span>
                              }
                            </button>
                          }

                          <!-- Pulsante aggiuntivo per la variante senza profilo, se presente -->
                          @if (targetAppWithProfiles.noProfileApp) {
                            <button
                              type="button"
                              class="btn btn-outline-secondary btn-profile text-start"
                              [disabled]="!targetAppWithProfiles.noProfileApp.app.abilitato"
                              (click)="onAppSenzaProfiloClick(targetAppWithProfiles.noProfileApp.key, targetAppWithProfiles.noProfileApp.app)"
                              [ngbTooltip]="targetAppWithProfiles.noProfileApp.app.abilitato ? 'Accedi senza profilo' : 'Applicazione non disponibile'"
                              container="body"
                            >
                              senza profilo
                            </button>
                          }
                        </div>
                      </div>
                  </div>
                </div>
              }
            }
          </div>
        }

        <!-- Empty State -->
        @if (!isLoadingApps() && !hasLandingApps()) {
          <div class="card">
            <div class="card-body text-center py-5">
              <i class="bi bi-app-indicator text-muted mb-3" style="font-size: 4rem;"></i>
              <h5 class="mb-2">Nessuna applicazione disponibile</h5>
              <p class="text-muted mb-0">Non ci sono applicazioni disponibili al momento.</p>
            </div>
          </div>
        }
      </div>

      @if (showWidgetComunicazioni) {
        <div class="col-12 col-xl-4">
          <div class="landing-widget-slot">
            <div class="landing-widget-header">
              <h2 class="landing-title mb-0">
                <span class="landing-title-primary">Le tue </span>
                <span class="landing-title-warning">comunicazioni</span>
              </h2>
              @if (widgetComunicazioniCount() > 0) {
                <span class="badge bg-primary rounded-pill">{{ widgetComunicazioniCount() }}</span>
              }
            </div>

            @if (isLoadingWidgetComunicazioni()) {
              <div class="landing-widget-state text-center py-4">
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Caricamento widget comunicazioni...
              </div>
            } @else if (hasWidgetComunicazioniError()) {
              <div class="landing-widget-state text-center py-4 text-muted">
                Impossibile caricare il widget comunicazioni.
              </div>
            } @else if (widgetComunicazioniHtml()) {
              <div #widgetContent class="landing-widget-content" [innerHTML]="widgetComunicazioniHtml()"></div>
            } @else {
              <div class="landing-widget-state text-center py-4 text-muted">
                Nessuna comunicazione disponibile.
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>

  <app-footer></app-footer>
</div>

